



















import { index } from '@/api/merchant_orders'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {}
})

export default class extends Vue {
  config: Record<string, any> = {
    api: index,
    include: 'brand',
    paginate: true,
    fields: [
      { prop: 'id', label: '#', width: 60 },
      { prop: 'paid_total', label: 'Total', width: 120 },
      { prop: 'merchant', label: 'Merchant', slot: true },
      { prop: 'store', label: 'Store', slot: true },
      { prop: 'created_at', label: 'Created time', width: 150 }
    ]
  }
}
